import {convertQueryInputToSingleElement} from '../../common/shared/utils/convertQueryInputToSingleElement';

export function getTodayNewParamFromQuery({
  uidInfoList,
}: {
  uidInfoList: string[];
}) {
  const [category_uid, subcategory_uid] = uidInfoList;
  const categoryUid = convertQueryInputToSingleElement(category_uid);
  const subcategoryUid = convertQueryInputToSingleElement(subcategory_uid);
  return {
    categoryUid: Number(categoryUid),
    subcategoryUid,
  };
}
